export const reduxKey = '@@publicSession';
